<style scoped="scoped" lang="scss">
</style>
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/customer/dictionary/type/page"
			getKey="rows" :columns="columns" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('zidianleixingbianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianleixingmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary"
					v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('zidianzhi', scope.row,'w2')">
							{{$t('zidianzhi')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/customer/dictionary/type/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('zidianleixingbianma')" required="required">
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianleixingmingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionary/type/create')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder"  :label="$t('zidianleixingbianma')" required="required">
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianleixingmingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionary/type/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 字典值 -->

			<template v-if="yt.editObj.action == 'zidianzhi'">
				<div class="dialog-scroller">
					<dictionary_item :typeId="yt.editObj"></dictionary_item>
					<!-- <span slot="footer" class="dialog-footer" style="float: right;">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button size="mini" @click="yt.isShowEditDialog = false" type="primary">{{$t('baocun')}}
						</el-button>
					</span> -->
				</div>
				
			</template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import dictionary_item from '@@/pages/admin/data_template/dictionary/dictionary_item'
	export default {
		name: 'admin_data_template_dictionary_list',

		components: {
			dictionary_item
		},
		data() {
			return {
				list: [],
				columns: [{
					label: 'zidianleixingbianma',
					prop: 'code',
				}, {
					label: 'zidianleixingmingcheng',
					prop: 'name',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 220,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				// this.yt.conditions = {
				// 	pageNum: 1,
				// 	pageSize: 10
				// }	
				this.yt.get(1);
				this.getList()
			}, 300)

		},
		methods: {
			// 获取列表数据
			// async getList() {
			// 	let response = await this.http.get('/web/equipment/fault/template/page', {
			// 		platform: 1,
			// 		pageNum: 1,
			// 		pageSize: 1000
			// 	})
			// 	console.log("list", response.data.rows)
			// 	this.list = response.data.rows
			// },
			// 重置

		}
	};
</script>
